import React from "react";
import BulkUpdateTdsPropertiesModal from "../../components/BulkUpdateTdsProperties/FileUploadModal";

const BulkUpdateTdsProperties = (props) => {
  return <BulkUpdateTdsPropertiesModal />;
};

export default BulkUpdateTdsProperties;
